var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBhutan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 27.3138C21.0653 33.5622 10.9347 33.5622 4.68625 27.3138C-1.56212 21.0654 -1.56212 10.9347 4.68625 4.6863C4.6885 4.6863 19.0649 0.438363 25.3133 6.68674C31.5618 12.9351 27.318 27.3094 27.3137 27.3138Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.314 27.3138C33.5623 21.0654 33.5623 10.9347 27.314 4.6863C21.0656 -1.56213 10.935 -1.56207 4.68652 4.6863L27.314 27.3138Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1826 20.1838C19.5254 20.4419 18.7617 20.4145 18.0991 20.0427C16.9285 19.3857 16.5106 17.8986 17.1678 16.7278L16.9683 16.6159C18.9728 16.1326 20.4557 14.3132 20.4297 12.1662C20.4136 10.8314 19.8171 9.63719 18.8842 8.82007L17.4234 10.3167C17.9756 10.7568 18.3337 11.4319 18.3429 12.1915C18.3591 13.534 17.2803 14.6394 15.9378 14.6556L15.9406 14.8842C14.5198 13.3901 12.2028 13.0155 10.3565 14.1115C9.20863 14.793 8.47276 15.9065 8.23145 17.1231L10.2579 17.6399C10.363 16.9416 10.7686 16.2939 11.4218 15.9061C12.5762 15.2208 14.0729 15.6026 14.7583 16.7569L14.955 16.6403C14.3714 18.6176 15.2054 20.8116 17.0779 21.8626C18.242 22.5159 19.5743 22.5965 20.7485 22.1972L20.1826 20.1838ZM15.9546 16.0466L15.9545 16.0467L15.9546 16.0466Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9241 10.8362L20.7933 14.8719L17.4001 14.2454L15.216 9.74316L9.31557 11.837L8.85025 10.5257L7.3065 10.3355L8.46969 13.6136L12.5303 12.5751L13.6842 15.8269L10.8772 19.9695L15.6408 24.0324L14.7378 25.0909L15.345 26.5231L17.6024 23.8766L14.6728 20.8793L16.9119 18.2541L21.9031 18.6137L23.0399 12.4569L24.4081 12.7095L25.3449 11.4677L21.9241 10.8362ZM15.9988 16.1088V16.1089V16.1088Z",
    fill: "#FFEACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBhutan);
export default __webpack_public_path__ + "static/media/flag_bhutan.74647ad89c7bd9d8b903a3fbb98c4bdc.svg";
export { ForwardRef as ReactComponent };